<div class="ili-panel inquiry_panel">
  <p style="font-size: 11px;">Separate multiple email addresses with a comma followed by a space</p>
  <mat-form-field>
    <input matInput [(ngModel)]="block.data.email" class="form-control input-sm" type="text" placeholder="To email address">
  </mat-form-field>
  <mat-form-field>
    <input matInput [(ngModel)]="block.data.inquiryText" class="form-control input-sm" type="text" placeholder="Type your inquiry here">
  </mat-form-field>
</div>
